<script>
import Layout from "@/router/layouts/main";
import Stat from "@/components/widgets/stat";
import { api } from "@/state/services";
import { required, minLength } from "vuelidate/lib/validators";
import Password from "@/components/widgets/input-password";

export default {
  components: {
    Layout,
    Stat,
    Password,
  },
  data() {
    return {
      filter: {
        status: "all",
      },

      search: "",

      statData: [
        { type: "line", icon: "bx-user-x", title: "Inativos", value: "-" },
        { type: "line", icon: "bx-user-check", title: "Ativos", value: "-" },
      ],

      fields: [
        { key: "name", label: "Nome" },
        { key: "cellphone", label: "Celular" },
        { key: "email", label: "Email" },
        { key: "licenses", label: "Licenças" },
        { key: "expiration", label: "Expiração" },
        { key: "status", label: "Status" },
        { key: "actions", label: "", tdClass: 'text-right' },
      ],

      total: 0,
      currentPage: "1",
      perPage: "25",

      balance: {
        available: 0,
        blocked: 0,
      },

      clients: null,

      add: {
        modal: false,
        loading: false,
        name: "",
        email: "",
        cellphone: "",
      },

      added: {
        modal: false,
        name: "",
        email: "",
        cellphone: "",
        password: "",
      },

      view: {
        modal: false,
        client: {
          id: null,
          status: "",
          date_added: "",
          date_approved: "",
          name: "",
          email: "",
          cellphone: "",
        }
      },

      products: [],

      payment: {
        modal: false,
        client: null,
        product: "",
      },

      del: {
        modal: false,
        loading: false,
        client: null,
      },
    };
  },
  validations: {
    add: {
      name: { required },
      email: { required },
      cellphone: { required },
      password: { required, minLength: minLength(6) },
    },
  },
  methods: {
    getClients() {
      this.clients = null;

      api
        .get("saas/clients?status=" + this.filter.status)
        .then((response) => {
          if (response.data.status == "success") {
            this.total = response.data.list.length;

            this.balance.available = response.data.balance.available;
            this.balance.blocked = response.data.balance.blocked;

            this.statData = [
              { type: "line", icon: "bx-user-x", title: "Inativos", value: response.data.total.pending.toString() },
              { type: "line", icon: "bx-user-check", title: "Ativos", value: response.data.total.approved.toString() },
            ];

            this.clients = response.data.list;
          }
        })
        .catch((error) => {
          if (error) {
            this.clients = [];
          }
        })
    },
    showAdd() {
      this.add.modal = false;
      this.add.modal = true;
      this.add.loading = false;
    },
    addClient() {
      this.add.loading = true
      this.$v.add.$touch();

      if (!this.$v.add.$invalid) {
        api
          .post('saas/clients', {
            name: this.add.name,
            cellphone: this.add.cellphone,
            email: this.add.email,
            password: this.add.password,
          })
          .then(response => {
            if (response.data.status == 'success') {
              this.add.name = ''
              this.add.cellphone = ''
              this.add.email = ''
              this.add.password = ''
              this.$v.add.$reset()

              this.add.modal = false
              this.add.loading = false

              this.$toast.success('O cliente adicionado com sucesso!')

              this.added.modal = false;
              this.added.modal = true;
              this.added.name = response.data.client.name;
              this.added.cellphone = response.data.client.cellphone;
              this.added.email = response.data.client.email;
              this.added.password = response.data.client.password;

              this.getClients()
            } else {
              this.add.loading = false
              this.$toast.error(response.data.message)
            }
          })
          .catch(error => {
            if (error) {
              this.add.loading = false
            }
          })
      } else {
        this.add.loading = false
      }
    },
    showView(client) {
      this.view.modal = false;
      this.view.modal = true;
      this.view.client = client;
    },
    showPayment(client) {
      this.payment.modal = false;
      this.payment.modal = true;
      this.payment.client = client;

      api
        .get('saas/extract')
        .then((response) => {
          if (response.data.status == 'success') {
            this.products = response.data.balances;
          } else {
            this.products = [];
          }
        })
    },
    activateClient(id) {
      this.payment.loading = true;

      api
        .post('saas/clients/activate', {
          id: id,
          product: this.payment.product,
        })
        .then((response) => {
          if (response.data.status == "success") {
            this.$toast.success("O pagamento foi realizado com sucesso!");

            this.payment.modal = false;
            this.payment.loading = false;
            this.view.modal = false;

            this.getClients();
          } else {
            this.$toast.error(response.data.message);
            this.payment.loading = false;
          }
        })
        .catch((error) => {
          if (error) {
            this.$toast.error("Erro ao realizar pagamento, tente novamente.");
            this.payment.loading = false;
          }
        });
    },
    showDel(client) {
      this.del.modal = false;
      this.del.modal = true;
      this.del.client = client;
    },
    delClient(id) {
      this.del.loading = true;

      api
        .post('saas/clients/delete', {
          id: id
        })
        .then((response) => {
          if (response.data.status == "success") {
            this.$toast.success("O cliente foi excluído com sucesso!");

            this.del.modal = false;
            this.del.loading = false;
            this.view.modal = false;

            this.getClients();
          } else {
            this.$toast.error(response.data.message);
            this.del.loading = false;
          }
        })
        .catch((error) => {
          if (error) {
            this.$toast.error("Erro ao excluir cliente, tente novamente.");
            this.del.loading = false;
          }
        });
    },
  },
  mounted() {
    this.getClients();
  },
  watch: {
    "filter.status": function () {
      this.getClients();
    },
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item">Produtos</li>
      <li class="breadcrumb-item d-none d-sm-block">Clientes</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Clientes</h3>
        <p></p>
      </div>
    </div>

    <div class="row">
      <div v-for="(stat, index) of statData" :key="index" class="col-6 col-md-3">
        <Stat :type="stat.type" :icon="stat.icon" :title="stat.title" :value="stat.value" />
      </div>
    </div>

    <div id="dropdown" class="d-flex mb-4">
      <b-dropdown variant="outline-light">
        <template #button-content>
          ações
          <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
          </svg>
        </template>
        <b-dropdown-item v-on:click="showAdd();">Novo</b-dropdown-item>
      </b-dropdown>
      <b-dropdown variant="outline-light">
        <template #button-content>
          <div class="d-flex justify-content-between align-items-center">
            <div class="text-left">
              <h6 class="m-0 text-secondary">Status</h6>
              <div v-if="filter.status == 'all'">Todos</div>
              <div v-else-if="filter.status == 'pending'">Inativo</div>
              <div v-else-if="filter.status == 'approved'">Ativo</div>
            </div>
            <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="m12 14.168-5.582-5.61L5 9.967 12 17l7-7-1.415-1.414L12 14.168Z" fill="currentColor"></path>
            </svg>
          </div>
        </template>
        <b-dropdown-form><b-form-radio v-model="filter.status" value="all">Todos</b-form-radio></b-dropdown-form>
        <b-dropdown-form><b-form-radio v-model="filter.status" value="pending">Inativo</b-form-radio></b-dropdown-form>
        <b-dropdown-form><b-form-radio v-model="filter.status" value="approved">Ativo</b-form-radio></b-dropdown-form>
      </b-dropdown>
      <div class="totals pt-3">
        <h6 class="m-0 text-secondary text-lowercase">Total</h6>
        <div>{{ this.total }}</div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="min-vh-25 text-center d-flex justify-content-center align-items-center" v-if="!clients">
          <b-spinner variant="default" role="status"></b-spinner>
        </div>

        <div v-else-if="clients && clients.length == 0" class="min-vh-25 text-center d-flex justify-content-center align-items-center">
          <div>
            <i class="far fa-sad-cry font-size-24"></i><br>
            nenhum registro encontrado
          </div>
        </div>

        <div v-else class="table-responsive">
          <b-input v-model="search" placeholder="Busca" class="mb-4"></b-input>

          <b-table :items="clients" :fields="fields" class="table-nowrap table-style table-hover table-pointer min-vh-25" head-variant="light" @row-clicked="showView" :current-page="currentPage"
            :per-page="perPage" :filter="search" responsive>
            <template #cell(licenses)="row">
              {{ row.item.licenses.length }}
            </template>
            <template #cell(expiration)="row">
              <span v-if="row.item.licenses && row.item.licenses.length > 0">
                {{ row.item.licenses.find(l => l.status === 'active')
                   ? row.item.licenses.find(l => l.status === 'active').date_expiration
                   : row.item.licenses[row.item.licenses.length - 1].date_expiration }}
              </span>
              <span v-else>-</span>
            </template>
            <template #cell(status)="row">
              <span class="badge badge-soft-danger font-size-13" v-if="row.item.status == 'pending'">INATIVO</span>
              <span class="badge badge-soft-success font-size-13" v-else-if="row.item.status == 'approved'">ATIVO</span>
              <span class="badge badge-soft-warning font-size-13" v-else-if="row.item.status == 'deleted'">EXCLUÍDO</span>
              <span class="badge badge-soft-warning font-size-13" v-else-if="row.item.status == 'canceled'">CANCELADO</span>
            </template>
            <template #cell(actions)="row">
              <div v-if="row">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
                  <path d="M12 9a3.02 3.02 0 0 0-3 3c0 1.642 1.358 3 3 3 1.641 0 3-1.358 3-3 0-1.641-1.359-3-3-3z"></path>
                  <path
                    d="M12 5c-7.633 0-9.927 6.617-9.948 6.684L1.946 12l.105.316C2.073 12.383 4.367 19 12 19s9.927-6.617 9.948-6.684l.106-.316-.105-.316C21.927 11.617 19.633 5 12 5zm0 12c-5.351 0-7.424-3.846-7.926-5C4.578 10.842 6.652 7 12 7c5.351 0 7.424 3.846 7.926 5-.504 1.158-2.578 5-7.926 5z">
                  </path>
                </svg>
              </div>
            </template>
          </b-table>

          <b-pagination v-if="search == ''" class="mt-4" v-model="currentPage" :total-rows="total" :per-page="perPage" pills align="center"></b-pagination>
        </div>
      </div>
    </div>

    <b-modal v-model="add.modal" title="Novo Cliente" modal-class="modal-right" hide-footer>
      <b-form @submit.prevent="addClient">
        <b-form-group id="name-group" label="Nome" label-for="name">
          <b-form-input id="name" v-model="add.name" type="text" :class="{ 'is-invalid': $v.add.name.$error }"></b-form-input>
          <div v-if="!$v.add.name.required" class="invalid-feedback">
            O nome é obrigatório.
          </div>
        </b-form-group>

        <b-form-group id="cellphone-group" label="Celular/Whatsapp" label-for="cellphone">
          <b-form-input id="cellphone" v-model="add.cellphone" type="text" v-mask="'(##) #####-####'" :class="{ 'is-invalid': $v.add.cellphone.$error }" inputmode="numeric"></b-form-input>
          <div v-if="!$v.add.cellphone.required" class="invalid-feedback">
            O celular é obrigatório.
          </div>
        </b-form-group>

        <b-form-group id="email-group" label="Email" label-for="email">
          <b-form-input id="email" v-model="add.email" type="email" :class="{ 'is-invalid': $v.add.email.$error }" inputmode="email"></b-form-input>
          <div v-if="!$v.add.email.required" class="invalid-feedback">
            O email é obrigatório.
          </div>
        </b-form-group>

        <b-form-group id="password-group" label="Senha" label-for="password">
          <Password v-model="add.password" :v="$v.add.password"></Password>
        </b-form-group>

        <b-button class="mt-5 btn-lg btn-block" :disabled="this.add.loading" type="submit" variant="default">
          Adicionar
          <b-spinner v-if="add.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
        </b-button>
      </b-form>
    </b-modal>

    <b-modal v-model="added.modal" title="Dados do Cliente" modal-class="modal-right" hide-footer>
      <div class="mb-3">
        O cliente foi adicionado com sucesso!
      </div>
      <div class="mb-3"><strong class="font-size-12">Nome</strong><br><span class="font-size-16">{{ added.name }}</span></div>
      <div class="mb-3"><strong class="font-size-12">Celular</strong><br><span class="font-size-16">{{ added.cellphone }}</span></div>
      <div class="mb-3 d-flex justify-content-between align-items-center">
        <div>
          <strong class="font-size-12">Email</strong><br>
          <span class="font-size-16">{{ added.email }}</span>
        </div>
        <div>
          <button class="btn btn-link p-0 m-0" v-clipboard:copy="this.added.email" v-on:click="$toast.success('Copiado!');">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: #000;">
              <path
                d="M20 2H10c-1.103 0-2 .897-2 2v4H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2v-4h4c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM4 20V10h10l.002 10H4zm16-6h-4v-4c0-1.103-.897-2-2-2h-4V4h10v10z">
              </path>
            </svg>
          </button>
        </div>
      </div>
      <div class="mb-3 d-flex justify-content-between align-items-center">
        <div>
          <strong class="font-size-12">Senha</strong><br>
          <span class="font-size-16">{{ added.password }}</span>
        </div>
        <div>
          <button class="btn btn-link p-0 m-0" v-clipboard:copy="this.added.password" v-on:click="$toast.success('Copiado!');">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: #000;">
              <path
                d="M20 2H10c-1.103 0-2 .897-2 2v4H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2v-4h4c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM4 20V10h10l.002 10H4zm16-6h-4v-4c0-1.103-.897-2-2-2h-4V4h10v10z">
              </path>
            </svg>
          </button>
        </div>
      </div>
    </b-modal>

    <b-modal v-model="view.modal" title="Dados do Cliente" modal-class="modal-right" hide-footer>
      <div>
        <div class="mb-3"><strong class="font-size-12">Criado em {{ view.client.date_added }}</strong></div>
      </div>
      <div class="mb-3"><strong class="font-size-12">Nome</strong><br><span class="font-size-16">{{ view.client.name }}</span></div>
      <div class="mb-3"><strong class="font-size-12">Celular</strong><br><span class="font-size-16">{{ view.client.cellphone }}</span></div>
      <div class="mb-3"><strong class="font-size-12">Email</strong><br><span class="font-size-16">{{ view.client.email }}</span></div>
      <div class="mb-3">
        <strong class="font-size-12">Status</strong><br>
        <span class="badge badge-soft-danger p-2 font-size-14" v-if="view.client.status == 'pending'">INATIVO</span>
        <template v-else-if="view.client.status == 'approved'">
          <span class="badge badge-soft-success p-2 mb-1 mr-1 font-size-14">ATIVO</span>
          <span class="font-size-14 text-center">{{ view.client.date_approved }}</span>
        </template>
      </div>
      <template v-if="view.client && view.client.licenses && view.client.licenses.length > 0">
        <fieldset v-for="(license, index) of view.client.licenses" :key="index" class="pb-3">
          <legend class="font-size-14 text-uppercase">{{ license.type }} - {{ license.plan }}</legend>
          <div class="mb-2"><strong class="font-size-12">Código</strong><br><span class="font-size-16">{{ license.code }}</span></div>
          <div class="mb-2">
            <strong class="font-size-12">Status</strong><br>
            <span class="badge badge-soft-danger p-2 font-size-14" v-if="license.status == 'inactive'">AGUARDANDO ATIVAÇÃO</span>
            <span class="badge badge-soft-success p-2 font-size-14" v-else-if="license.status == 'active'">ATIVO</span>
            <span class="badge badge-soft-warning p-2 font-size-14" v-else-if="license.status == 'expired'">EXPIRADO</span>
          </div>
          <div class="mb-2" v-if="license.status == 'active'"><strong class="font-size-12">Data de Ativação</strong><br><span class="font-size-16">{{ license.date_activated }}</span></div>
          <div class="mb-2" v-if="license.status == 'active'"><strong class="font-size-12">Data de Expiração</strong><br><span class="font-size-16">{{ license.date_expiration }}</span></div>
        </fieldset>
      </template>
      <div class="mt-5">
        <button v-if="view.client.status == 'pending'" class="btn btn-success btn-lg btn-block" v-on:click="showPayment(view.client)">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor;">
            <path d="M12 16c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zm0-6c1.084 0 2 .916 2 2s-.916 2-2 2-2-.916-2-2 .916-2 2-2z"></path>
            <path
              d="m2.845 16.136 1 1.73c.531.917 1.809 1.261 2.73.73l.529-.306A8.1 8.1 0 0 0 9 19.402V20c0 1.103.897 2 2 2h2c1.103 0 2-.897 2-2v-.598a8.132 8.132 0 0 0 1.896-1.111l.529.306c.923.53 2.198.188 2.731-.731l.999-1.729a2.001 2.001 0 0 0-.731-2.732l-.505-.292a7.718 7.718 0 0 0 0-2.224l.505-.292a2.002 2.002 0 0 0 .731-2.732l-.999-1.729c-.531-.92-1.808-1.265-2.731-.732l-.529.306A8.1 8.1 0 0 0 15 4.598V4c0-1.103-.897-2-2-2h-2c-1.103 0-2 .897-2 2v.598a8.132 8.132 0 0 0-1.896 1.111l-.529-.306c-.924-.531-2.2-.187-2.731.732l-.999 1.729a2.001 2.001 0 0 0 .731 2.732l.505.292a7.683 7.683 0 0 0 0 2.223l-.505.292a2.003 2.003 0 0 0-.731 2.733zm3.326-2.758A5.703 5.703 0 0 1 6 12c0-.462.058-.926.17-1.378a.999.999 0 0 0-.47-1.108l-1.123-.65.998-1.729 1.145.662a.997.997 0 0 0 1.188-.142 6.071 6.071 0 0 1 2.384-1.399A1 1 0 0 0 11 5.3V4h2v1.3a1 1 0 0 0 .708.956 6.083 6.083 0 0 1 2.384 1.399.999.999 0 0 0 1.188.142l1.144-.661 1 1.729-1.124.649a1 1 0 0 0-.47 1.108c.112.452.17.916.17 1.378 0 .461-.058.925-.171 1.378a1 1 0 0 0 .471 1.108l1.123.649-.998 1.729-1.145-.661a.996.996 0 0 0-1.188.142 6.071 6.071 0 0 1-2.384 1.399A1 1 0 0 0 13 18.7l.002 1.3H11v-1.3a1 1 0 0 0-.708-.956 6.083 6.083 0 0 1-2.384-1.399.992.992 0 0 0-1.188-.141l-1.144.662-1-1.729 1.124-.651a1 1 0 0 0 .471-1.108z">
            </path>
          </svg>
          Ativar Produto
        </button>
        <button v-else class="btn btn-success btn-lg btn-block" disabled>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor">
            <path
              d="M12 15c-1.84 0-2-.86-2-1H8c0 .92.66 2.55 3 2.92V18h2v-1.08c2-.34 3-1.63 3-2.92 0-1.12-.52-3-4-3-2 0-2-.63-2-1s.7-1 2-1 1.39.64 1.4 1h2A3 3 0 0 0 13 7.12V6h-2v1.09C9 7.42 8 8.71 8 10c0 1.12.52 3 4 3 2 0 2 .68 2 1s-.62 1-2 1z">
            </path>
            <path d="M5 2H2v2h2v17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V4h2V2H5zm13 18H6V4h12z"></path>
          </svg>
          Ativar Produto
        </button>
      </div>
      <div class="mt-3">
        <button v-if="view.client.status == 'pending'" class="btn btn-danger btn-lg btn-block" v-on:click="showDel(view.client)">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor">
            <path d="M5 20a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8h2V6h-4V4a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v2H3v2h2zM9 4h6v2H9zM8 8h9v12H7V8z"></path>
            <path d="M9 10h2v8H9zm4 0h2v8h-2z"></path>
          </svg>
          Excluir Cliente
        </button>
        <button v-else class="btn btn-danger btn-lg btn-block" disabled>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor">
            <path d="M5 20a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8h2V6h-4V4a2 2 0 0 0-2-2H9a2 2 0 0 0-2 2v2H3v2h2zM9 4h6v2H9zM8 8h9v12H7V8z"></path>
            <path d="M9 10h2v8H9zm4 0h2v8h-2z"></path>
          </svg>
          Excluir Cliente
        </button>
      </div>
    </b-modal>

    <b-modal v-model="payment.modal" modal-class="modal-bottom" hide-footer hide-header>
      <div class="px-3">
        <h5 class="mb-4" v-if="payment.client">Deseja realizar ativação do cliente <span class="bg-soft-dark px-2 rounded text-uppercase">{{ payment.client.name }}</span>?</h5>
        <div class="mb-4">
          <select v-model="payment.product" class="custom-select mb-1">
            <option value="">– Selecione um produto</option>
            <option v-for="(option, index) in products" :key="index" :value="option.id">
              {{ option.name }} –
              <template v-if="option.total > 0">
                {{ option.total }} disponíveis
              </template>
              <template v-else>
                {{ option.total }} disponível
              </template>
            </option>
          </select>
        </div>
        <div class="mt-4 d-flex justify-content-between">
          <b-button class="btn-lg" variant="default" :disabled="this.payment.loading" v-on:click="activateClient(view.client.id)">
            Ativar
            <b-spinner v-if="payment.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
          </b-button>
          <b-button class="text-dark text-decoration-none" variant="link" v-on:click="payment.modal = false">Fechar</b-button>
        </div>
      </div>
    </b-modal>

    <b-modal v-model="del.modal" modal-class="modal-bottom" hide-footer hide-header>
      <div class="px-3">
        <h5>Você tem certeza que deseja excluir este cliente?</h5>
        <div class="mt-4 d-flex justify-content-between">
          <b-button class="btn-lg" variant="danger" :disabled="this.add.loading" v-on:click="delClient(view.client.id)">
            Excluir
            <b-spinner v-if="del.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
          </b-button>
          <b-button class="text-dark text-decoration-none" variant="link" v-on:click="del.modal = false">Fechar</b-button>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>

<style scoped>
button:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}
</style>

<style>
.pendings-client {
  padding: 0 !important;
  margin: 0 !important;
  margin-bottom: 10px !important;
}

.pendings-client * {
  cursor: pointer !important;
}

.pendings-client .custom-control-label:before {
  top: 20px;
  left: 16px;
  width: 20px;
  height: 20px;
}

.pendings-client .custom-control-label:after {
  top: 20px;
  left: 16px;
  width: 20px;
  height: 20px;
}

.pendings-client .custom-control-label {
  padding: 15px 15px 15px 50px;
  width: 100%;
}

.pendings-client.client-selected {
  background-color: #bdf4d5 !important;
}

.pendings-client.client-selected .custom-control-input:checked~.custom-control-label::before {
  border-color: #34C391 !important;
  background-color: #34C391 !important;
}
</style>
